import queryString from "query-string";

import Axios from "@app/api/axios";

import { SOURCE_DATA_API } from "@utils/constant";

const getSourceDataById = (sourceDataId = "", params = {}) => {
  const url = queryString.stringifyUrl(
    {
      url: SOURCE_DATA_API,
      query: {
        "filter[search][columns]": "id,",
        "filter[search][value]": sourceDataId,
        include: "court",
      },
    },
    { encode: false }
  );

  return Axios.get(url, params).then(response => response.data);
};

export default getSourceDataById;
